import React, { FC } from 'react';

import JourneySlideover from 'src/common/JourneySlideOver';
import { CreateOrganizationForm } from 'src/dashboard/forms/create-organization-form';

interface Props {
  isCreatingOrganization: boolean;
  handleFormClose: () => void;
}

const CreateOrganizationSlideover: FC<Props> = ({ isCreatingOrganization, handleFormClose }) => {
  return (
    <JourneySlideover
      title={`Create New Organization`}
      open={isCreatingOrganization}
      maxWidth='xs'
      onClose={handleFormClose}
      isBedrock={true}
    >
      <div className='flex flex-col space-y-4'>
        <CreateOrganizationForm />
      </div>
    </JourneySlideover>
  );
};

export default CreateOrganizationSlideover;
